export const homepageData = {
  hero: {
    title: "随时随地 享受专业体育运动体验",
    subtitle: "云体育 · 一站式在线体育运动服务平台",
    cta: "立即加入",
    secondaryCta: "了解更多",
    stats: [
      { value: "500万+", label: "活跃用户" },
      { value: "2000+", label: "精品课程" },
      { value: "100+", label: "赛事直播" },
      { value: "98%", label: "用户好评率" },
    ],
  },
  services: [
    {
      id: "saishizhibo",
      title: "赛事直播",
      description: "全球顶级体育赛事高清直播，专业解说带您身临其境",
      icon: "ri-live-line",
      features: ["足球/篮球/网球/电竞", "多机位自由切换", "实时数据统计"],
    },
    {
      id: "yundongkecheng",
      title: "运动课程",
      description: "体系化专业运动课程，从入门到进阶全面提升",
      icon: "ri-book-open-line",
      features: ["瑜伽/普拉提/搏击/舞蹈", "专业教练团队", "分阶段系统学习"],
    },
    {
      id: "jianshenjihua",
      title: "健身计划",
      description: "个性化健身方案定制，AI智能匹配最佳训练方案",
      icon: "ri-heart-pulse-line",
      features: ["减脂/增肌/塑形", "AI智能匹配", "数据追踪分析"],
    },
    {
      id: "tiyuzixun",
      title: "体育资讯",
      description: "汇聚全球体育最新资讯，掌握体育圈大小事",
      icon: "ri-newspaper-line",
      features: ["赛事战报/转会动态", "深度分析/专访", "实时推送"],
    },
  ],
  membership: {
    title: "会员权益",
    subtitle: "开通云体育会员，解锁全部专业运动体验",
    plans: [
      {
        name: "基础会员",
        price: "29",
        period: "月",
        features: ["高清赛事直播", "基础课程观看", "每日资讯推送", "社区讨论参与"],
        highlighted: false,
      },
      {
        name: "高级会员",
        price: "69",
        period: "月",
        features: ["全部赛事直播", "全部课程无限看", "AI健身计划定制", "专属教练答疑", "去广告体验", "优先客服支持"],
        highlighted: true,
      },
      {
        name: "年度会员",
        price: "588",
        period: "年",
        features: ["高级会员全部权益", "线下活动优先参与", "运动装备折扣", "1对1私教指导", "年度运动报告"],
        highlighted: false,
      },
    ],
  },
  faqs: [
    {
      question: "云体育平台支持哪些设备？",
      answer: "云体育支持全平台使用，包括网页端、iOS App、Android App、智能电视和iPad。您可以在任何设备上随时随地进行学习和观看直播。",
    },
    {
      question: "如何取消会员订阅？",
      answer: "您可以在个人中心-会员管理中找到取消订阅选项。取消后当前周期的会员权益将持续到周期结束，不会产生额外费用。",
    },
    {
      question: "课程是否有观看期限？",
      answer: "会员期间所有课程均无观看次数限制。部分付费单节课程的观看期限为购买后180天，具体请查看课程详情页的说明。",
    },
    {
      question: "健身计划是否适合零基础用户？",
      answer: "当然适合！我们的AI智能系统会根据您的体能水平、运动经验和目标，为每位用户量身定制适合自己的训练计划，从零基础到进阶选手都能找到合适的方案。",
    },
    {
      question: "赛事直播是否有回放功能？",
      answer: "所有直播赛事均提供赛后回放功能，高级会员可以观看全部历史赛事的完整回放和精彩集锦。基础会员可观看最近7天的赛事回放。",
    },
  ],
  testimonials: [
    {
      name: "张先生",
      role: "健身爱好者",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%20on%20white%20background%2C%20clean%20minimalist%20style%2C%20warm%20natural%20lighting%2C%20friendly%20expression&width=100&height=100&seq=yunsports-avatar-1&orientation=squarish",
      content: "云体育的AI健身计划真的帮了我大忙！三个月减了12公斤，而且整个过程都有数据追踪，特别科学。",
    },
    {
      name: "李女士",
      role: "瑜伽爱好者",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%20on%20white%20background%2C%20clean%20minimalist%20style%2C%20warm%20natural%20lighting%2C%20friendly%20smile&width=100&height=100&seq=yunsports-avatar-2&orientation=squarish",
      content: "课程质量很高，教练讲解很细致。在家就能跟着专业教练练习，省去了去健身房的通勤时间，太方便了。",
    },
    {
      name: "王同学",
      role: "大学生",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20headshot%20on%20white%20background%2C%20clean%20minimalist%20style%2C%20warm%20natural%20lighting%2C%20bright%20expression&width=100&height=100&seq=yunsports-avatar-3&orientation=squarish",
      content: "赛事直播画质超棒，和室友一起看NBA太爽了！而且还能参与社区讨论，认识了很多志同道合的朋友。",
    },
  ],
};